<template>
  <div class="content delete-account-page">
    <h1>Delete Account</h1>

    <b-alert
      v-if="error"
      variant="danger"
      show
    >
      {{ error }}
    </b-alert>

    <div class="text-center">
      <template v-if="!confirmedOnce">
        <p>
          Are you sure you want to permanently delete your account?
          This will cancel any active subscriptions and remove your access
          to the app. This cannot be undone.
        </p>

        <b-button
          variant="danger"
          class="mb-3"
          @click="confirmedOnce = true"
        >
          Yes, Delete My Account
        </b-button>

        <b-button
          type="button"
          variant="secondary"
          @click="$router.push({ name: editAccountRouteName })"
        >
          Cancel
        </b-button>
      </template>

      <template v-else>
        <p>
          This is permanent. Tap again to confirm you want to delete
          your account.
        </p>

        <b-button
          variant="danger"
          class="mb-3"
          :disabled="buttonClicked"
          @click="deleteAccount"
        >
          <template v-if="buttonClicked">
            Deleting
            <spinner />
          </template>
          <template v-else>
            Confirm Delete Account
          </template>
        </b-button>

        <b-button
          type="button"
          variant="secondary"
          :disabled="buttonClicked"
          @click="confirmedOnce = false"
        >
          Go Back
        </b-button>
      </template>
    </div>
  </div>
</template>

<script>
import Spinner from '../../components/Spinner.vue';

export default {
  name: 'DeleteAccount',
  components: {
    Spinner,
  },
  data() {
    return {
      confirmedOnce: false,
      buttonClicked: false,
      error: '',
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    editAccountRouteName() {
      return this.$route.params.clientSlug || this.$route.params.client_slug
        ? 'client-edit_account'
        : 'edit_account';
    },
  },
  metaInfo: {
    title: 'Delete Account',
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$nextTick(() => {
      const main = document.querySelector('main');
      if (main) main.scrollTop = 0;
    });
  },
  methods: {
    async deleteAccount() {
      this.buttonClicked = true;
      this.error = '';

      let response;

      try {
        response = await fetch(
          `${process.env.VUE_APP_API_URL}users/${this.userData.id}/delete_account/`,
          {
            method: 'DELETE',
            headers: {
              Authorization: `Token ${this.userData.drf_token}`,
            },
          },
        );
      } catch (e) { // eslint-disable-line no-empty
      }

      if (response && response.status === 204) {
        this.logUserOut();
        return;
      }

      this.buttonClicked = false;
      this.error = 'We could not delete your account. Please try again or contact support.';
    },
  },
};
</script>
